export const ID_TOKEN = "ID_TOKEN";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const IS_EMAIL = /^[\w-.']+@([\w-]+\.)+[\w-]{2,4}$/;
export const IS_URL = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
export const SUPPORT_EMAIL_LINK =
  "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=gears_help@globalpay.com";
export const DATE_FORMAT = "yyyy-MM-dd";
export const GEARS_TOKEN = "GEARS_TOKEN";
export const GEARS_TOKEN_EXPIRATION_DATE = "GEARS_TOKEN_EXPIRATION_DATE";
